import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import Form from "../common/Form";
import Section from "../common/Section";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as types from "../../constants/ComponentConstants";

import redirector from "../../util/redirector.js";

class AanvraagBevestigingPage extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	// ----------------------------------------------------------------------------
	componentWillMount() {
		const { aanvraag, dossierId, loadLayout } = this.props;
		if (!aanvraag)
			redirector.goToHome();
		else
			loadLayout(aanvraag.naam,aanvraag.tabTitel, dossierId, aanvraag.initialisatieOK);
	}
	// ----------------------------------------------------------------------------
	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.props.aanvraag) {
			return false;
		}

		return true;
	}
	gaVerder(dossierId) {
		return function () {
			redirector.goTo('/project/' + dossierId);
		};
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		const { aanvraag } = this.props;

		return (
			<Section title="Ga verder" color={types.COLOR_BLUE}>
				<Form
					title="Aanvraag aangemaakt"
					name="bevestiging"
					isNotRequired
					rightButtonLabel="Ga verder"
					onRightButtonClick={this.gaVerder(aanvraag.dossierId)}>
					<Fieldset>
						Via een code die zal opgestuurd worden naar het e-mail adres van
					de contactpersonen kan je dit dossier later terug oproepen.
				</Fieldset>
				</Form>
			</Section>
		);
	}
}

// ----------------------------------------------------------------------------
AanvraagBevestigingPage.propTypes = {
	aanvraag: PropTypes.object,
	loadLayout: PropTypes.func,
	dossierId: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	let dossierId = undefined;
	if (state.aanvraag.item) {
		dossierId = state.aanvraag.item.dossierId;
	}
	return {
		dossierId: dossierId,
		aanvraag: state.aanvraag.item
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadAanvraagBevestigingsLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AanvraagBevestigingPage);
